/** Material Symbols Rounded icon per category slug (Home tabs, Explore chips). */
export const CATEGORY_ICONS: Record<string, string> = {
  trending: 'local_fire_department',
  'change-outfit': 'checkroom',
  'hair-salon': 'content_cut',
  makeup: 'brush',
  'face-expression': 'mood',
  christmas: 'park',
  'happy-birthday': 'redeem',
  family: 'family_restroom',
  'india-costume': 'apparel',
  anime: 'animation',
  'pet-memories': 'pets',
  'star-style': 'star',
  couple: 'favorite',
  romance: 'volunteer_activism',
  'ai-figure': 'smart_toy',
  'tiny-world': 'movie',
  'viral-video': 'auto_awesome',
};
